import { LinkButton, Typography } from "@bca/ui-library";
import React from "react";

export const contactInfo = {
  phone: "0344 875 3480",
  mail: "bcabuyersupport@bca.com",
};

const ContactSupport = ({
  callCustomerServiceOnClickHandler = () => {},
  emailCustomerServiceOnClickHandler = () => {},
}) => (
  <>
    <Typography margin={0} variant="body" mb={2}>
      Customer Service
    </Typography>
    <Typography variant="body" margin={0} mb={2}>
      <LinkButton
        color="primary"
        shouldOpenInNewWindow
        variant="tertiary"
        href={`tel:${contactInfo.phone}`}
        css="text-decoration: underline;"
        padding={0}
        height={0}
        fontSize="body"
        onClick={callCustomerServiceOnClickHandler}
      >
        {contactInfo.phone}
      </LinkButton>
    </Typography>
    <Typography margin={0} variant="body">
      <LinkButton
        href={`mailto:${contactInfo.mail}`}
        color="primary"
        shouldOpenInNewWindow
        variant="tertiary"
        css="text-decoration: underline;"
        padding={0}
        height={0}
        fontSize="body"
        onClick={emailCustomerServiceOnClickHandler}
      >
        {contactInfo.mail}
      </LinkButton>
    </Typography>
  </>
);

export default ContactSupport;
